<script setup lang="ts">
/**
 * @author Giorgi Tseradze
 */

//
import LockSVG from "./SVG/LockSVG.vue";
import { isInView } from "@/composables/utils/isInView";
import { onMounted, Ref, ref } from "vue";
import { ListDataInterface } from "@/types/ContentType";
const Picture = defineAsyncComponent(
  () => import("@/components/regularComponents/UIComponents/Picture.vue")
);

defineProps<{
  content: ListDataInterface;
  index: number;
}>();

const isTrigger: Ref<boolean> = ref(false);
const innerCard = ref();

onMounted(() => {
  setTimeout(() => {
    window?.addEventListener("scroll", () => {
      isTrigger.value = isInView(innerCard.value!, 1);
    });
  }, 2000);
});
</script>
<template>
  <section
    class="management__inner-card"
    ref="innerCard"
    :class="isTrigger ? 'is-inview' : ''"
  >
    <div class="management__inner-image pos-rel">
      <Picture
        :devices="content?.image?.[0]?.devices"
        imgClass="img-absolute"
        alt="apartment"
      />
    </div>
    <div class="management__inner-text">
      <div class="management__inner-text-lock" v-if="index === 0"><LockSVG /></div>
      <div
        class="management__inner-text-title uppercase"
        :class="index % 2 !== 0 ? 'management__inner-title-odd' : ''"
      >
        <h2 class="hl-3">{{ content?.title }}</h2>
      </div>
      <div
        class="management__inner-text-teaser"
        :class="index % 2 !== 0 ? 'management__inner-teaser-odd' : ''"
      >
        <!-- <p class="p-12">{{ content?.teaser }}</p> -->
        <div class="p-12" v-html="content?.teaser"></div>
      </div>
    </div>
  </section>
</template>

<style lang="scss"></style>
